var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"observer"},[_c('i',{staticClass:"observer-top"}),_c('i',{staticClass:"observer-bottom"})])
}]

export { render, staticRenderFns }